import { Component, OnInit } from '@angular/core';
import { AuthIdentityResponse } from '../../../../data/models/interfaces/auth-response.interface';
import { SelectTenantService } from '../../../../data/services/select-tenant.service';
import { SelectUserSchoolService } from '../../../../data/services/select-user-school.service';
import { UserUtil } from '../../../../data/utils/user.utils';
import { SchoolDto } from '../../../../data/models/dto/school.dto';

@Component({
  selector: 'app-select-tenant-dialog',
  templateUrl: './select-tenant-dialog.component.html',
  styleUrls: ['./select-tenant-dialog.component.scss']
})
export class SelectTenantDialogComponent implements OnInit {
  identities: AuthIdentityResponse[] = [];
  schools: SchoolDto[] = [];
  loading: boolean = false;
  shouldSelectSchool: boolean = false;

  constructor(
    private readonly selectTenantService: SelectTenantService,
    private readonly selectSchoolService: SelectUserSchoolService,
    private readonly userUtil: UserUtil
  ) { }

  ngOnInit(): void {
    this.identities = this.selectTenantService.getIdentities();
  }

  async selectIdentity(identity: AuthIdentityResponse): Promise<void> {
    try {
      this.loading = true;
      
      await this.selectTenantService.selectIdentity(identity);

      if(this.userUtil.isAdminProfile() && this.userUtil.hasManySchools()) {
        this.schools = this.selectSchoolService.getUserSchools();
        this.shouldSelectSchool = true;
        return;
      }

      window.location.reload();
    } catch (error) {
      console.log('failed to select identity (tenant)', error);
    }
    finally {
      this.loading = false;
    }
  }

  async selectSchool(school: SchoolDto): Promise<void> {
    try {
      this.loading = true;

      await this.selectSchoolService.selectUserSchool(school);

      window.location.reload();
    } catch (error) {
      console.log('failed to select school', error);
    }
    finally {
      this.loading = false;
    }
  }
}
